import {css, StyleSheet} from 'aphrodite';
import produce from 'immer';
import React from 'react';

import {SchemaField} from 'schemas/fields/SchemaFieldConstants';

import FilterLookupStepPopover from './FilterLookupStepPopover';
import {FilterLookupStepInfo, LookupStepInfo} from './LookupConfigModalConstants';
import {getLookupStepInfoWithType} from './LookupConfigUtils';

export interface FilterLookupGroupPopoverProps {
  disabled: boolean;
  lookupStepGroup: Array<LookupStepInfo>;
  handleSetLookupStepGroup: (lookupStepGroup: Array<LookupStepInfo>) => void;
  hasError?: boolean;
  allowInventoryFilters?: boolean;
  schemaFieldFilterFn?: (field: SchemaField, excludeNonLinkFields: boolean) => boolean;
}

export function FilterLookupGroupPopover(props: FilterLookupGroupPopoverProps): JSX.Element | null {
  const lastStep = props.lookupStepGroup[props.lookupStepGroup.length - 1];
  if (!lastStep) {
    return null;
  }
  const lookupStepInfoWithType = getLookupStepInfoWithType(lastStep);
  const lastStepSchema = lookupStepInfoWithType?.linkSchema;
  if (!lastStepSchema) {
    return null;
  }
  return (
    <FilterLookupStepPopover
      className={css(styles.filterButton)}
      disabled={props.disabled}
      hasError={props.hasError}
      parentSchema={lastStepSchema}
      parentLookupStepInfo={lastStep}
      allowInventoryFilters={props.allowInventoryFilters}
      filterLookupSteps={lastStep.filterLookupSteps || []}
      handleSetFilterLookupSteps={(filterLookupSteps: Array<FilterLookupStepInfo>) => {
        const newLookupStepGroup = produce(props.lookupStepGroup, (draftGroup) => {
          draftGroup[draftGroup.length - 1].filterLookupSteps = filterLookupSteps;
        });
        props.handleSetLookupStepGroup(newLookupStepGroup);
      }}
      schemaFieldFilterFn={props.schemaFieldFilterFn}
    />
  );
}

const styles = StyleSheet.create({
  filterButton: {
    marginLeft: '-9px',
    marginRight: '6px',
  },
});
